import hyperdom from 'hyperdom'
import PaymentGatewayDeposit from './paymentGatewayDeposit.jsx'

export default class FakePaymentGatewayDeposit extends PaymentGatewayDeposit {
  constructor (payment, fastTrack) {
    super (payment, fastTrack)
    this.needUpdate = true
    this.method = 'creditcard'
    this.paymentMethods = {
      creditcard: 'Credit Card',
      paypal: 'PayPal',
      banktransfer: 'Bank Transfer',
      credit_agreement: 'Credit Agreement',
      moreoptions: 'More Options',
      unknown: 'unknown', //???
    }
  }

  injectScript () {
    this.paymentGatewayUrl = 'http://localhost:7589/'
    super.injectScript()
  }

  paymentOptionName () {
    return '[Fake] Pay only a deposit'
  }

  onrender () {
    if (this.payment.paymentOption() === this) {
      if(this.needUpdate) {
        this.updateOptionsAndRender()
      }
    } else {
      this.needUpdate = true
    }
  }

  methodRenderer () {
    return <div>
      <div className="conditions">
        { this.payment.renderTermsAndConditions() }
      </div>
      <button className="pay-now-btn" onclick= {(ev) => {ev.preventDefault();this.sendPaymentRequest(this.method)}}>{this.paymentMethods[this.method]}</button>
    </div>
  }

  paymentGatewayContainer () {
    if (this.payment.paymentOption() === this) {
      return <div id="payment-gateway-component">
        {Object.entries(this.paymentMethods).map(([key,name]) => <button id={key} onclick={(ev) => {ev.preventDefault(); this.method = key}}>{name}</button>)}
        <div id="payment-form">{this.methodRenderer()}</div>
      </div>
    }
  }

  sendPaymentRequest (paymentMethod) {
    this.payment.showLoading()
    const req = new XMLHttpRequest()
    req.open('POST', `${this.paymentGatewayUrl}paymentGateway`, true)
    req.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
    req.onload = () => this.paymentGatewayResponseHandler(JSON.parse(req.responseText))
    req.send(JSON.stringify({
      totalAmount: this.amount(),
      paymentMethod,
      paymentStatus: 'partiallyPaid',
      bookingId: this.payment.booking.booking.bookingId,
    }))
  }

  attachPaymentOptions () {
    this.needUpdate = false
    const req = new XMLHttpRequest()
    req.open('POST', `${this.paymentGatewayUrl}options`, true)
    req.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
    req.send(JSON.stringify(this.options))
  }
}
